import { formPost, htmlGet, jsonPost } from '../components/ajax';
import { API_REFERENCE } from '../utilities/constant_api';
import { iosSelectmenuAccessibilityFixes } from '../utilities/utility';
var changeQuantityTrigger = false;
var saveSupplyDetailsFlag = false;
let cartRemoveItemAjaxRequest = true;
const limitRequestUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.cart.saveSupplyDetails}`;
EPST.cart = {
  _autoload: [
    //Functions binding should be present here which need to be called on load
    'validateCartPage'
  ],

  bundleToggle: function() {
    $(this)
      .closest(this.parentElement.parentElement)
      .append($('.cart-bundle-item'));
    $('.cart-bundle-item').slideToggle();
    var buttonText =
      $(this).html() === 'SHOW BUNDLE ITEMS'
        ? 'HIDE BUNDLE ITEMS'
        : 'SHOW BUNDLE ITEMS';
    $(this).html(buttonText);
  },

  remove: function() {
    $(this.parentElement.parentElement).css({ display: 'none' });
  },

  stickyItemRemove: function() {
    const entryNumber = $(this).attr('data-entry-product-code');
    const method = 'POST';
    const removeItemCartUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.cart.removeItemFromStickyCart}${entryNumber}`;
    if (!cartRemoveItemAjaxRequest) return false;
    cartRemoveItemAjaxRequest = false;
    formPost(removeItemCartUrl)
      .then(data => {
        if (data.trim() === 'redirect:/') {
          window.location.href = `${ACC.config.encodedContextPath}/`;
        } else if(data.trim() === 'redirect:/checkout') {
        	window.location.href = `${ACC.config.encodedContextPath}/checkout`;
        } else {
          location.reload();
        }
      })
      .catch(error => {
        cartRemoveItemAjaxRequest = true;
      });
  },

  changeBillingOption: function() {
    $('.cart-checkout__button , .modify-order-checkout-button').attr('disabled', true);
    var $that = $(this);
    var $cartItemParent = $that.parents('.cart-item');
    var requestURL = `${ACC.config.encodedContextPath}${API_REFERENCE.cart.cartBillingOptionUpdate}`;
    var objParam = {
      entryNumber: $cartItemParent.data('entry'),
      billingOption: $that.val()
    };
    const jsonData = JSON.stringify(objParam);
    jsonPost(requestURL, jsonData).then(response => {
      location.reload();
        }
      );
  },

  changeSupplyPeriod: function() {
    var $that = $(this);
    var $cartItemParent = $that.parents('.cart-item');
    var $cartSupplyPeriodParent = $that.parents('.cart-item-supply-period');
    var requestURL = limitRequestUrl;
    var showLimitMessage = false;
    var objParam = {
      entryNumber: $cartItemParent.data('entry'),
      productCode: $cartItemParent.data('product-code').toString(),
      supplyPeriodUnit: $that.val(),
      supplyPeriodDuration: $cartSupplyPeriodParent
        .find('.weekandmonth')
        .val()
        .slice(0, 1),
      quantity: $cartItemParent.find('.cart-item-quantity .quant').val(),
      selectedItem: 'supplyPeriod'
    };
    EPST.cart.limitRequest(
      $cartItemParent,
      requestURL,
      objParam,
      showLimitMessage
    );
    EPST.cart.validateCartPage();
  },

  changeQuantity: function() {
    changeQuantityTrigger = true;
    var $that = $(this);
    var $cartItemParent = $that.parents('.cart-item');
    var requestURL = limitRequestUrl;
    var showLimitMessage = true;
    var $supplyPeriodParent = $cartItemParent.find('.cart-item-supply-period');
    var supplyPeriodUnit = '';
    var supplyPeriodDuration = '';
    if ($supplyPeriodParent.length > 0) {
      supplyPeriodUnit = $supplyPeriodParent
        .find('.quantandnum')
        .val()
        .toString();
      supplyPeriodDuration = $supplyPeriodParent
        .find('.weekandmonth')
        .val()
        .slice(0, 1);
    }
    else if($cartItemParent.find('.weekandmonth-hidden').length > 0){
		supplyPeriodDuration = $cartItemParent.find('.weekandmonth-hidden').val().slice(0, 1);
		supplyPeriodUnit = $cartItemParent.find('.js-change-supply-period-hidden').val();
		 }
    var objParam = {
      entryNumber: $cartItemParent.data('entry'),
      productCode: $cartItemParent.data('product-code').toString(),
      supplyPeriodUnit: supplyPeriodUnit,
      supplyPeriodDuration: supplyPeriodDuration,
      quantity: $that.val(),
      selectedItem: 'quantity'
    };
    EPST.cart.limitRequest(
      $cartItemParent,
      requestURL,
      objParam,
      showLimitMessage
    );
  },

  limitRequest: function(
    $cartItemParent,
    requestURL,
    objParam,
    showLimitMessage
  ) {
    if ($('.global-alerts .alert-danger').length == 0) {
      $('.global-error-message-container').addClass('hidden');
    }
    const objParamData = JSON.stringify(objParam);
    jsonPost(requestURL, objParamData).then(response => {
      if (
        response.errorMessage != '' &&
        response.errorMessage != null &&
        response.errorMessage != undefined
      ) {
        saveSupplyDetailsFlag = true;
        if ($('.global-alerts .alert-danger').length == 0) {
          $('.global-error-message-container')
            .removeClass('hidden')
            .find('.generic-error-text')
            .text(response.errorMessage);
        }
        window.scrollTo(0, 0);
      } else if (changeQuantityTrigger == true) {
        saveSupplyDetailsFlag = false;
        location.reload();
      } else {
        if (showLimitMessage) {
          saveSupplyDetailsFlag = false;
          $('.nav-cart .js-mini-cart-count')
            .find('.badge')
            .text(response.totalCartQuantity);
        }
        var responseMessage =
          response.messageText !== '' && response.messageText !== null
            ? response.messageText
            : '';
        var $cartItem = $cartItemParent.find('.cart-item-limit-message');
        $cartItem
          .text(responseMessage)
          .toggleClass('hidden', responseMessage === '');
      }

      EPST.cart.validateCartPage();
    });
  },

  changeSupplyPeriodDuration: function() {
    var $that = $(this);
    var $cartSupplyPeriodParent = $that.parents('.cart-item-supply-period');
    var duration = $cartSupplyPeriodParent.find('.weekandmonth').val();
    var $cartItemWeekText = $cartSupplyPeriodParent.find(
      '.cart-item__week-text'
    );
    var $cartChangeSupplyPeriod = $cartSupplyPeriodParent.find(
      '.js-change-supply-period'
    );
    var maxSupplyPeriodUnit = $cartItemWeekText.data('max-supply-unit');
    var maxSupplyPeriodDuration = $cartItemWeekText.data('max-supply-duration');
    var totalDuration = maxSupplyPeriodUnit;

    if (duration === 'Months') {
      if (maxSupplyPeriodDuration === 'Weeks') {
        totalDuration = maxSupplyPeriodUnit / 4;
      }
      $cartChangeSupplyPeriod.empty();
      $cartChangeSupplyPeriod.append("<option class='hidden'></option>");
      for (var i = 1; i <= totalDuration; i++) {
        $cartChangeSupplyPeriod.append(
          '<option value=' + i + '>' + i + '</option>'
        );
      }
    } else if (duration === 'Weeks') {
      if (maxSupplyPeriodDuration === 'Months') {
        totalDuration = maxSupplyPeriodUnit * 4;
      }
      $cartChangeSupplyPeriod.empty();
      $cartChangeSupplyPeriod.append("<option class='hidden'></option>");
      for (var i = 1; i <= totalDuration; i++) {
        $cartChangeSupplyPeriod.append(
          '<option value=' + i + '>' + i + '</option>'
        );
      }
    }
    $cartChangeSupplyPeriod.selectmenu('refresh');
    EPST.cart.validateCartPage();
  },

  displayLoginPopup: function() {
    $('.header-signin')[0].click();
  },

  setupLimitRequest: function(item) {
    let $cartItem = $(item).parents('.cart-item');
    let requestURL = limitRequestUrl;
    let showLimitMessage = true;
    let $supplyPeriodParent = $cartItem.find('.cart-item-supply-period');
    let supplyPeriodUnit = '';
    let supplyPeriodDuration = '';
    if ($supplyPeriodParent.length > 0) {
      supplyPeriodUnit = $supplyPeriodParent
        .find('.quantandnum')
        .val()
        .toString();
      supplyPeriodDuration = $supplyPeriodParent
        .find('.weekandmonth')
        .val()
        .slice(0, 1);
    }
     else if($cartItem.find('.weekandmonth-hidden').length > 0){
		supplyPeriodUnit = $cartItem.find('.js-change-supply-period-hidden').val();
		supplyPeriodDuration = $cartItem.find('.weekandmonth-hidden').val().slice(0, 1);
	}
    var objParam = {
      entryNumber: $cartItem.data('entry'),
      productCode: $cartItem.data('product-code').toString(),
      supplyPeriodUnit: supplyPeriodUnit,
      supplyPeriodDuration: supplyPeriodDuration,
      quantity: $(item).val(),
      selectedItem: 'quantity'
    };
    EPST.cart.limitRequest($cartItem, requestURL, objParam, showLimitMessage);
  },

  validateCartPage: function() {
    let supplyPeriodEmptyFlag = false;
    const $checkoutButton = $('.js-continue-checkout-button');

    const $supplyPeriodEle = $('.cart-item-supply-period .quantandnum');
    if ($supplyPeriodEle.length > 0) {
      $supplyPeriodEle.each(function() {
        if ($(this).val() == '') {
          supplyPeriodEmptyFlag = true;
        }
      });
    }
    if (
      $('.global-alerts .alert-danger').length > 0 ||
      saveSupplyDetailsFlag == true
    ) {
      supplyPeriodEmptyFlag = true;
    }
    $checkoutButton.prop('disabled', supplyPeriodEmptyFlag);
  },

  showBundleItems: function() {
    $('.cart-item-kits').toggleClass('show');
    $('.btn-show-bundle').toggleClass('show');
  },

  expandMobileStickyCart: function(e) {
    $('.sticky-cart-container').toggleClass('mobile-expanded');
    $('body').toggleClass('mobile-sticky-extended');
    EPST.cart.resizeFunction();
    e.stopImmediatePropagation(e);
    if ($('.sticky-cart-container').hasClass('mobile-expanded')) {
      $('.sticky-cart-container').attr('role', 'dialog');
      $('.close-mobile-sticky-cart-btn').focus();
      $('.sticky-cart-wrapper').show();
    } else {
      $('.sticky-cart-container').attr('aria-expanded', false);
      $('.sticky-cart-container').attr('role', 'link');
      setTimeout(function() {
        $('.sticky-cart-container').focus();
      }, 100);
      $('.sticky-cart-wrapper').hide();
    }
  },

  stickyScroll: function() {
    if ($('.sticky-outside').length > 0) {
      var firstAnchorOffsetTop, docScrollTop, footerOffset, bottomOffset;

      firstAnchorOffsetTop = $('.navbar-fixed-top').height() + 15;

      docScrollTop = $(document).scrollTop();
      footerOffset = $('footer.footer').offset().top;
      bottomOffset = docScrollTop + $('.sticky-cart-container').height() + 500;

      var top_of_footer = $('footer.footer').offset().top;
      var bottom_of_footer =
        $('footer.footer').offset().top + $('footer.footer').outerHeight() + 30;
      var bottom_of_screen = $(window).scrollTop() + window.innerHeight;
      var top_of_screen = $(window).scrollTop();
      var topOffset;

      if ($(window).outerWidth() > 1367) {
        $('.sticky-outside, .sticky-cart-container').css(
          'height',
          $('.sticky-outside')
            .parent()
            .children()
            .first()
            .outerHeight() +
            20 +
            'px'
        );

        // when reached bottom of footer
        if (
          bottom_of_screen > top_of_footer &&
          top_of_screen < bottom_of_footer
        ) {
          $('.sticky-cart-container')
            .removeClass('sticky')
            .addClass('bottom-sticky');
          $('.sticky-cart-container.sticky').css('width', 'auto');
        } else if (docScrollTop > firstAnchorOffsetTop) {
          // during sticky scrolling
          topOffset = $('.nav-header').height();
          $('.sticky-cart-container')
            .removeClass('bottom-sticky')
            .addClass('sticky');
          $('.sticky-cart-container.sticky').css('top', topOffset + 'px');
          $('.sticky-cart-container.sticky').css(
            'width',
            $('.sticky-outside').width() + 'px'
          );
          var stickyLeft =
            $('.sticky-outside').offset().left +
            $('.sticky-outside').width() -
            $('.sticky').width() -
            2;
          $('.sticky').css('left', stickyLeft);
        } else {
          // before sticky scroll
          $('.sticky-cart-container')
            .removeClass('bottom-sticky')
            .removeClass('sticky');
          $('.sticky-cart-container.sticky').css('top', 'initial');
          $('.sticky-cart-container.sticky').css('width', 'auto');
        }
      } else {
        $('.sticky-outside, .sticky-cart-container').css(
          'height',
          'auto !important'
        );

        if (!$('body').hasClass('mobile-sticky-extended')) {
          $('.sticky-cart-container').css(
            'top',
            String(
              $(window).outerHeight() -
                $('.sticky-cart-mobile-expand-btn').outerHeight()
            ) + 'px'
          );
        }
      }
    }
  },
  resizeFunction() {
    if (window.innerWidth >= 768 && window.innerWidth < 1368) {
      $('.mobile-expanded .checkout-order-summary').css(
        'max-height',
        window.innerHeight - $('header').height() - 15
      );
    } else if (window.innerWidth < 768) {
      $('.mobile-expanded .checkout-order-summary').css(
        'max-height',
        window.innerHeight - $('header').height()
      );
    }
  }
};

$(document).ready(function() {
  EPST.cart.stickyScroll();
  $('.sticky-cart-container').attr('aria-expanded', false);
  $('.sticky-cart-container').attr('aria-label', 'cart summary');
  $('.cart-bundle-item').hide();
  $('.cart-tooltip').attr('title', 'This is the hover-over text');
  $('[data-toggle="tooltip"]').tooltip();
  $('.cart-item-button-bundle--show').on('click', EPST.cart.bundleToggle);
  $('.cart-item-remove').on('click', EPST.cart.remove);
  $(document).on(
    'click',
    '.stickycart-item-remove',
    EPST.cart.stickyItemRemove
  );

  $(document).on('click', '.btn-show-bundle', EPST.cart.showBundleItems);

  $('.js-update-quantity').selectmenu();
  $('.js-update-quantity').selectmenu({
    open: function() {
      $('div.ui-selectmenu-open').addClass('qty_dropdown');
      iosSelectmenuAccessibilityFixes($(this));
    },
    close: function() {
      $(this)
        .next('.ui-selectmenu-button')
        .focus();
    }
  });
  $('.js-change-supply-period').selectmenu({
    open: function() {
      iosSelectmenuAccessibilityFixes($(this));
    },
    close: function() {
      $(this)
        .next('.ui-selectmenu-button')
        .focus();
    }
  });
  $('.cart-item-right-panel__billing').selectmenu({
    open: function() {
      iosSelectmenuAccessibilityFixes($(this));
    },
    close: function() {
      $(this)
        .next('.ui-selectmenu-button')
        .focus();
    }
  });
  $('.js-change-supply-period-duration').selectmenu({
    open: function() {
      iosSelectmenuAccessibilityFixes($(this));
    },
    close: function() {
      $(this)
        .next('.ui-selectmenu-button')
        .focus();
    }
  });
  $('.js-update-quantity').each(function(item, index) {
    EPST.cart.setupLimitRequest(index);
  });

  $(document).on(
    'click',
    '.cart-item-right-panel .ui-selectmenu-button',
    ACC.utility.setDropdownHeight
  );
  $(document).on(
    'selectmenuchange',
    '.js-change-supply-period',
    EPST.cart.changeSupplyPeriod
  );
  $(document).on(
    'selectmenuchange',
    '.cart-item-right-panel__billing',
    EPST.cart.changeBillingOption
  );
  $(document).on(
    'selectmenuchange',
    '.js-change-supply-period-duration',
    EPST.cart.changeSupplyPeriodDuration
  );
  $(document).on(
    'selectmenuchange',
    '.js-update-quantity',
    EPST.cart.changeQuantity
  );
  if (window.innerWidth > 767) {
    $(document).on(
      'click',
      '.cart-page__signin_message',
      EPST.cart.displayLoginPopup
    );
  }

  $(document).on(
    'click',
    '.sticky-cart-mobile-expand-btn, .close-mobile-sticky-cart-btn',
    EPST.cart.expandMobileStickyCart
  );
  $(document).on(
    'keyup',
    '.sticky-cart-container, .close-mobile-sticky-cart-btn',
    enterkyfunction
  );
  $(document).on('keydown blur', '.cart-flow-back', tabkeyfunction);
  $(document).on('swiperight', swipefunction);

  function tabkeyfunction(e) {
    let keyCode = window.event ? e.which : e.keyCode;
    if (keyCode === 9) {
      EPST.cart.expandMobileStickyCart(e);
    }
  }

  function enterkyfunction(e) {
    let keyCode = window.event ? e.which : e.keyCode;
    if (keyCode === 13 || keyCode === 1) {
      if (this.classList.contains('sticky-cart-container')) {
        $('.sticky-cart-container').attr('aria-expanded', true);
      }
      EPST.cart.expandMobileStickyCart(e);
    }
  }
  function swipefunction(e) {
    if ($('.summary-Out-Focus:visible:last').is(':focus')) {
      EPST.cart.expandMobileStickyCart(e);
    }
  }

  $(window).scroll(EPST.cart.stickyScroll);
  $(window).resize(EPST.cart.stickyScroll);
  window.addEventListener('resize', EPST.cart.resizeFunction, true);

  function keepExpandCart(e) {
    if ($('.sticky-cart-container').hasClass('mobile-expanded')) {
      $(this).focus();
      e.stopPropagation();
    }
  }
  $(document).on('click', '.cart-item-tooltip', keepExpandCart);
});
